export const PARTICIPANT_ATTENDANCE_TYPES = {
  NO_FILTER: 0,
  FULL_ATTENDANCE: 1,
  NO_ATTENDANCE: 2,
  PARTIAL_ATTENDANCE: 3,
  UNRECOGNIZED: 4,
};

export const ATTENDANCE_STATUS = {
  COMPLETED: "completed",
  UPCOMING: "upcoming",
};
